<template>
  <div class="sub-title">
    {{title}}
  </div>
</template>
<script>
export default {
  name: 'SubTitle',
  props: {
    title: {
      type: String,
      require: true,
    },
  },
}
</script>
<style lang="less" scoped>
.sub-title {
  font-size: 16px;
  padding: 16px 0 16px 12px;
  position: relative;
  line-height: 18px;
  color: #494F69;
  font-weight: bold;
  &::before{
      content: '';
      position: absolute;
      border-radius: 4px;
      width: 4px;
      height: 18px;
      left: 0;
      top: 16px;
      background-color: #154F9D;
  }
}
</style>